@if (visible$ | async) {
<div class="container retail-product-list">
  <div class="row">
    <div class="col-lg-10">
      <h2 class="h3">{{ 'product.retailSet.products.heading' | translate }}</h2>
      <div class="product-list">
        @for (part of parts$ | async; track part; let i = $index) {
        <div class="row product-list-item list-view">
          @if (displayType() === 'tile') {
          <div class="col-6 col-lg-4 product-list-item grid-view">
            <ish-product-item
              displayType="tile"
              ishProductContext
              [sku]="part.sku"
              [propagateIndex]="i"
              [configuration]="{
                addToCompare: false,
                addToWishlist: false,
                addToOrderTemplate: false,
                addToQuote: false,
                addToBasket: false,
                ratings: true
              }"
            />
          </div>
          } @if (displayType() === 'row') {
          <div class="w-100 product-list-item grid-view">
            <ish-product-item
              displayType="row"
              ishProductContext
              [sku]="part.sku"
              [propagateIndex]="i"
              [allowZeroQuantity]="true"
              [configuration]="{
                addToCompare: false,
                addToWishlist: false,
                addToOrderTemplate: false,
                addToQuote: false,
                addToBasket: false,
                ratings: true,
                isRetailPart: true
              }"
            />
          </div>
          }
        </div>
        }
      </div>
      <div class="row product-info">
        <div class="col align-self-start no-gutters">
          <ish-product-add-to-basket />
          <ish-lazy-product-add-to-order-template />
        </div>
      </div>
    </div>
  </div>
</div>
}
